<template>
  <!-- Upload content -->
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="9">
          <v-btn class="mr-2" to="/admin/tiles/add" v-if="listView">Add</v-btn>
          <v-btn class="mr-2" to="/admin/tiles" v-else>Close</v-btn>
        </v-col>
        <v-col cols="3">
          <v-select
            :items="dropdownCategories"
            v-model="filters"
            @change="changeFilter"
          ></v-select>
        </v-col>
      </v-row>
      <h3 class="mb-4">Brand tiles</h3>
    </v-col>
    <v-col :cols="containerWidth">
      <v-row dense>
        <v-col
          v-for="(card, index) in list"
          :key="`card-${index}`"
          :cols="cardWidth"
        >
          <card-tile path="/admin/tiles" :card="card" />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="4">
      <router-view></router-view>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
const fb = require("@/firebaseConfig.js");
import router from "@/router";
import { store } from "@/store";
import CardTile from "./CardTile";

export default {
  name: "AdminTileList",
  data() {
    return {
      dropdownCategories: [
        "All",
        "Colour",
        "Illustration",
        "Pattern",
        "Photography",
        "Typography",
        "Word",
      ],
      collection: fb.tilesCollection,
      filters: "All",
      items: null,
      filtered: null,
      returnRoute: "AdminTileList",
    };
  },
  components: {
    CardTile,
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "tiles"]),
    listView() {
      return this.$route.name == "AdminTileList" ? true : false;
    },
    list() {
      if (this.filters == "All") {
        return this.tiles;
      } else {
        return this.tiles.filter((item) => item.category === this.filters);
      }
    },
    containerWidth() {
      return this.listView ? "12" : "8";
    },
    cardWidth() {
      return this.listView ? "3" : "4";
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    getItems() {
      const limit = this.$route.query.limit
        ? parseInt(this.$route.query.limit)
        : 9999;
      console.log("limit", limit);
      this.collection
        .limit(limit)
        .orderBy("createdOn", "desc")
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          store.commit("setTiles", items);
        });
    },
    deleteItem(id) {
      this.collection
        .doc(id)
        .delete()
        .then(() => {
          router.push({
            name: this.returnRoute,
          });
        })
        .catch((error) => {
          alert("Error removing document: ", error);
        });
    },
    changeFilter(val) {
      this.filters = val;
      this.getFilteredItems();
    },
  },
};
</script>
